// Shared layout constants.
//
// These live in their own module rather than in `index.js` because the navbar
// and sidebar need them too, and importing from `index.js` (which imports the
// navbar) would be a cycle.

// The feed and the post view render as a centred phone-width column on
// desktop. Every surface that has to line up with that column - the column
// itself, and the navbar that sits in the gutter beside it - measures from
// this one number.
export const PHONE_WIDTH = 480;
